import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import VendorRatingActions, { vendorRatingActionTypes } from '../../actions/configurations/vendorRatingActions';
import VendorRatingServices from '../../services/configurations/vendorRatingServices';

/**
 * @param action
 */

function* _createVendorRating(action) {
  try {
    yield put(VendorRatingActions.createVendorRatingLoading(true));
    const { payload } = action;
    const vendorRating = yield VendorRatingServices.createVendorRating(payload);
    if (!vendorRating.success) {
      notification.open({
        type: 'error',
        message: vendorRating?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Vendor Rating Submitted successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(vendorRating.seller);
      }
    }
    yield put(VendorRatingActions.createVendorRatingLoading(false));
  } catch (error) {
    yield put(VendorRatingActions.createVendorRatingLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* createVendorRating() {
  yield takeLatest(vendorRatingActionTypes.CREATE_VENDOR_RATING.REQUEST, _createVendorRating);
}

function* _updateVendorRating(action) {
  try {
    yield put(VendorRatingActions.updateVendorRatingLoading(true));
    const { payload } = action;
    const vendorRating = yield VendorRatingServices.updateVendorRating(payload);
    if (!vendorRating.success) {
      notification.open({
        type: 'error',
        message: vendorRating?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Vendor Rating updated successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(vendorRating.seller);
      }
    }
    yield put(VendorRatingActions.updateVendorRatingLoading(false));
  } catch (error) {
    yield put(VendorRatingActions.updateVendorRatingLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* updateVendorRating() {
  yield takeLatest(vendorRatingActionTypes.UPDATE_VENDOR_RATING.REQUEST, _updateVendorRating);
}

function* _updateVendorRatingSetting(action) {
  try {
    const { payload } = action;
    yield put(VendorRatingActions.updateVendorRatingSettingLoading(true));
    const vendorRating = yield VendorRatingServices.updateVendorRatingSetting(payload);
    if (vendorRating.success) {
      notification.open({
        type: 'success',
        message: vendorRating?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(VendorRatingActions.updateVendorRatingSettingLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: vendorRating?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(VendorRatingActions.updateVendorRatingSettingLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(VendorRatingActions.updateVendorRatingSettingLoading(false));
  }
}

/**
 *
 */
function* updateVendorRatingSetting() {
  yield takeLatest(vendorRatingActionTypes.UPDATE_VENDOR_RATING_CONFIG.REQUEST, _updateVendorRatingSetting);
}

/**
 * @param action
 */
function* _getVendorRating(action) {
  const {
    orgId, callback,
  } = action;
  try {
    VendorRatingActions.getVendorRatingSuccess(null);
    yield put(VendorRatingActions.getVendorRatingLoading(true));
    const vendorRating = yield VendorRatingServices.getVendorRating(orgId);
    yield put(VendorRatingActions.getVendorRatingSuccess(vendorRating?.data));
    if (callback) action.callback();
    yield put(VendorRatingActions.getVendorRatingLoading(false));
  } catch (error) {
    yield put(VendorRatingActions.getVendorRatingLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getVendorRating() {
  yield takeLatest(vendorRatingActionTypes.GET_VENDOR_RATING_CONFIG.REQUEST, _getVendorRating);
}

function* _enableVendorRatingConfig(action) {
  try {
    const { payload } = action;
    yield put(VendorRatingActions.enableVendorRatingConfigLoading(true));
    const enableVendorRating = yield VendorRatingServices.enableVendorRatingConfig(payload);
    if (enableVendorRating.success) {
      notification.open({
        type: 'success',
        message: 'Configuration updated successfully',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(VendorRatingActions.enableVendorRatingConfigLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: enableVendorRating?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(VendorRatingActions.enableVendorRatingConfigLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(VendorRatingActions.enableVendorRatingConfigLoading(false));
  }
}

/**
 *
 */
function* enableVendorRatingConfig() {
  yield takeLatest(vendorRatingActionTypes.ENABLE_VENDOR_RATING_CONFIG.REQUEST, _enableVendorRatingConfig);
}

export default function* VendorRatingSaga() {
  yield all([
    getVendorRating(), updateVendorRatingSetting(), enableVendorRatingConfig(), createVendorRating(), updateVendorRating(),
  ]);
}
